export default __webpack_public_path__ + "static/media/img16.9f1f558d.png";